import React, { useState, useEffect } from "react";
import { BASE_URL } from "../env";
import { store } from "react-notifications-component";

const NewQuestionCreate = () => {
	const [questionsArray, setquestionsArray] = useState([]);
	const [Questions, setQuestion] = useState([]);
	//   const [genre, setGenre] = useState("");
	//   const [nameoftheexam, setnameoftheexam] = useState("");
	//   const [timeoftheexam, settimeoftheexam] = useState("");
	//   const [starttimeoftheexam, setstarttimeoftheexam] = useState("");
	//   const [endtimeoftheexam, setendtimeoftheexam] = useState("");
	//   const [categoryoftheexam, setcategoryoftheexam] = useState("");
	//   const [typeOfExam, settypeOfExam] = useState("");

	const [courses, setCourses] = useState([]);
	const [course, setcourse] = useState("");

	useEffect(() => {
		// when the component will load

		fetch(BASE_URL + "/GetAllQuestionAdmin")
			.then((response) => response.json())
			.then((data) => {
				setQuestion(data?.questions);
			});
		return () => {
			// when the component will unmount from memory
		};
	}, []);

	function AddValueinArray(name) {
		if (questionsArray.includes(name)) {
			//remove the name from the array
			const newarray = questionsArray.filter((value) => value !== name);
			setquestionsArray(newarray);
			// console.log(newarray)
		} else {
			setquestionsArray([...questionsArray, name]);
		}
	}

	function CheckExistorNot(name, questionArray) {
		for (var singlevalue of questionArray) {
			if (singlevalue == name) {
				return true;
			}
		}
		return false;
	}
	useEffect(() => {
		console.log(questionsArray);
	}, [questionsArray]);

	useEffect(() => {
		fetch(BASE_URL + "/getallCourse")
			.then((res) => res.json())
			.then((data) => {
				setCourses(data?.courses);
				console.log(data?.courses);
			});
	}, []);

	//   const dta = () => {
	//     let questions = [];
	//     fetch(BASE_URL + "/addQuestionstoCourse", {
	//       method: "POST",
	//       headers: {
	//         "Content-Type": "application/json",
	//         Authorization: localStorage.getItem("token"),
	//       },
	//       body: JSON.stringify({ course, questionsArray }),
	//     })
	//       .then((res) => res.json())
	//       .then((data) => {
	//         console.log(data);
	//       })
	//       .catch((err) => {
	//         alert(err);
	//       });
	//   };

	function SubmitTheExam() {
		const notifyPopup = (msg) => {
			store.addNotification({
				title: "Success!",
				message: msg,
				type: "success",
				background: "pink",
				insert: "bottom",
				container: "bottom-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 3000,
					onScreen: true,
				},
			});
		};
		// let data = {};
		// if (starttimeoftheexam !== "" && endtimeoftheexam !== "") {
		//   data = {
		//     name: nameoftheexam,
		//     questions: questionsArray,
		//     timer: timeoftheexam,
		//     startTime: starttimeoftheexam,
		//     endTime: endtimeoftheexam,
		//     courseid: course,
		//     category: categoryoftheexam,
		//     typeOfExam: typeOfExam,
		//     genre,
		//   };
		// } else {
		//   data = {
		//     name: nameoftheexam,
		//     questions: questionsArray,
		//     timer: timeoftheexam,
		//     courseid: course,
		//     category: categoryoftheexam,
		//     typeOfExam: typeOfExam,
		//   };
		// }
		// console.log(data);
		// fetch(BASE_URL + "/createExamcoding", {
		//   method: "POST",
		//   headers: {
		//     "content-type": "application/json",
		//     Authorization: "Bearer " + localStorage.getItem("token"),
		//   },
		//   body: JSON.stringify(data),
		// })
		let questions = {
			courseid: course,
			questions: questionsArray,
		};
		fetch(BASE_URL + "/addQuestionstoCourse", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: localStorage.getItem("token"),
			},
			body: JSON.stringify(questions),
		})
			.then((res) => res.json())
			.then((data) => {
				notifyPopup(data?.message);
				console.log(data);
				// alert(data?.message);
			})
			.catch((err) => {
				alert(err);
			});
	}

	return (
		<div className="text-center">
			<div class="row">
				<div class="col-lg-offset-4">
					<br />
					<button
						onClick={SubmitTheExam}
						className="btn btn-danger btn-lg"
					>
						Add Questions to the exam
					</button>
					<br />
					<br />
					Choose the course for the exam
					<select
						className={`form-control mx-auto`}
						aria-label="Default select example"
						video=""
						id=""
						value={course}
						onChange={(e) => {
							setcourse(e.target.value);
							console.log(course);
						}}
					>
						<option value="">Select Course</option>
						{courses.map((val, index) => {
							return (
								<option key={index} value={val?._id}>
									{val?.name}
								</option>
							);
						})}
					</select>
					<br />
					<div className>
						Questions Added = {questionsArray.length}
						<br />
						<div className="row container">
							<p> Select the questions for the exam </p>

							{Questions.map((value, index) => {
								return (
									<div key={index} className="col-sm-4">
										<p
											className={
												CheckExistorNot(
													value._id,
													questionsArray
												)
													? "btn btn-success"
													: "btn btn-primary"
											}
											onClick={() => {
												AddValueinArray(value._id);
											}}
										>
											{++index}.{value.name}{" "}
											{CheckExistorNot(
												value._id,
												questionsArray
											) ? (
												<i class="fas fa-check-circle"></i>
											) : null}
										</p>
									</div>
								);
							})}
						</div>
						<button
							onClick={SubmitTheExam}
							className="btn btn-danger btn-lg"
						>
							Add Questions to the exam
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NewQuestionCreate;
